import { motion } from "framer-motion";
import { Copy } from "lucide-react";
import { STUDIO } from "@/lib/studio";

export const RequestFallback = ({ text, onCopy }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    data-testid="booking-fallback"
    className="rounded-2xl border border-gold/30 bg-champagne/70 p-5 sm:p-6"
    role="status"
  >
    <p className="font-serif text-xl text-ink">Dein E-Mail-Programm sollte sich jetzt öffnen.</p>
    <p className="mt-2 text-sm leading-relaxed text-ink-soft">
      Bitte prüfe die vorbereitete Nachricht und tippe dort auf „Senden“. Falls sich nichts geöffnet hat, kopiere die Anfrage und sende sie an{" "}
      <a href={`mailto:${STUDIO.email}`} className="text-gold-deep underline underline-offset-4">{STUDIO.email}</a>.
    </p>
    <pre data-testid="booking-fallback-text" className="mt-4 max-h-56 overflow-auto whitespace-pre-wrap rounded-xl bg-paper p-4 font-sans text-[13px] leading-relaxed text-ink" data-lenis-prevent>
      {text}
    </pre>
    <button type="button" onClick={onCopy} data-testid="booking-fallback-copy-btn" className="mt-4 inline-flex items-center gap-2 rounded-full border border-gold/50 px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-deep transition-colors duration-300 hover:bg-gold/10">
      <Copy className="h-4 w-4" /> Anfrage kopieren
    </button>
  </motion.div>
);
